let miniProjects = [
    {
      id: 1,
      title: "Sunglass Hut",
      img: "https://github.com/RomanSheikh99/Images/blob/main/projects/projects-1/project-1.png?raw=true"
    },
    {
      id: 2,
      title: "Tarunno Travel Agency",
      img: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-2/project-2.png?raw=true"
    },
    {
      id: 3,
      title: "DiPto Hospital LTD.",
      img: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-3/project-3.png?raw=true"
    },
    {
      id: 4,
      title: "Instru Music",
      img: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-4/project-4.png?raw=true"
    }
]
  
export default miniProjects;